var map = {
	"./de/cv-play.png": "a+zh",
	"./en/cv-play.png": "wp8D",
	"./es/cv-play.png": "qxWQ",
	"./fr/cv-play.png": "NQKU",
	"./ja/cv-play.png": "hRFa",
	"./ko/cv-play.png": "x14z",
	"./pt/cv-play.png": "Z+ln",
	"./ru/cv-play.png": "W1+H",
	"./tc/cv-play.png": "J27k",
	"./th/cv-play.png": "VLmu"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "W4o2";